module.exports = __webpack_public_path__ + "87d9b37b805c4ac45d38d80c9ab7dfe8.svg";